export const supportedLocales = new Set([
  'ar-QT',
  'ar-SA',
  'ar-fake',
  'ar',
  'cs-CZ',
  'cs',
  'da-DK',
  'da',
  'de-AT',
  'de-BE',
  'de-CH',
  'de-DE',
  'de',
  'el-CY',
  'el-GR',
  'el',
  'en-AE',
  'en-AU',
  'en-BH',
  'en-BN',
  'en-EG',
  'en-ES',
  'en-FJ',
  'en-GB',
  'en-IE',
  'en-IN',
  'en-KW',
  'en-LB',
  'en-LK',
  'en-MT',
  'en-MU',
  'en-MY',
  'en-NZ',
  'en-OM',
  'en-PH',
  'en-PK',
  'en-QT',
  'en-SA',
  'en-SG',
  'en-US',
  'en-ZA',
  'en',
  'et-EE',
  'et',
  'fi-FI',
  'fi',
  'fr-BE',
  'fr-CH',
  'fr-FR',
  'fr-MA',
  'fr-PF',
  'fr',
  'hr-HR',
  'hr',
  'it-CH',
  'it-IT',
  'it',
  'lt-LT',
  'lt',
  'lv-LV',
  'lv',
  'nl-BE',
  'nl',
  'pl-PL',
  'pl',
  'pt-PT',
  'pt',
  'ro-RO',
  'ro',
  'ru-EE',
  'ru-LV',
  'ru',
  'sk-SK',
  'sk',
  'sl-SI',
  'sl',
  'sr-RS',
  'sr',
]);
export const rollupLocales = new Map([
  ['ar-QT', ['ar-QT', 'ar', 'global']],
  ['ar-SA', ['ar-SA', 'ar', 'global']],
  ['ar-fake', ['ar-fake', 'ar', 'global']],
  ['ar', ['ar', 'global']],
  ['cs-CZ', ['cs-CZ', 'cs', 'global']],
  ['cs', ['cs', 'global']],
  ['da-DK', ['da-DK', 'da', 'global']],
  ['da', ['da', 'global']],
  ['de-AT', ['de-AT', 'de', 'global']],
  ['de-BE', ['de-BE', 'de', 'global']],
  ['de-CH', ['de-CH', 'de', 'global']],
  ['de-DE', ['de-DE', 'de', 'global']],
  ['de', ['de', 'global']],
  ['el-CY', ['el-CY', 'el', 'global']],
  ['el-GR', ['el-GR', 'el', 'global']],
  ['el', ['el', 'global']],
  ['en-AE', ['en-AE', 'en', 'global']],
  ['en-AU', ['en-AU', 'en', 'global']],
  ['en-BH', ['en-BH', 'en', 'global']],
  ['en-BN', ['en-BN', 'en', 'global']],
  ['en-EG', ['en-EG', 'en', 'global']],
  ['en-ES', ['en-ES', 'en', 'global']],
  ['en-FJ', ['en-FJ', 'en', 'global']],
  ['en-GB', ['en-GB', 'en', 'global']],
  ['en-IE', ['en-IE', 'en', 'global']],
  ['en-IN', ['en-IN', 'en', 'global']],
  ['en-KW', ['en-KW', 'en', 'global']],
  ['en-LB', ['en-LB', 'en', 'global']],
  ['en-LK', ['en-LK', 'en', 'global']],
  ['en-MT', ['en-MT', 'en', 'global']],
  ['en-MU', ['en-MU', 'en', 'global']],
  ['en-MY', ['en-MY', 'en', 'global']],
  ['en-NZ', ['en-NZ', 'en', 'global']],
  ['en-OM', ['en-OM', 'en', 'global']],
  ['en-PH', ['en-PH', 'en', 'global']],
  ['en-PK', ['en-PK', 'en', 'global']],
  ['en-QT', ['en-QT', 'en', 'global']],
  ['en-SA', ['en-SA', 'en', 'global']],
  ['en-SG', ['en-SG', 'en', 'global']],
  ['en-US', ['en-US', 'en', 'global']],
  ['en-ZA', ['en-ZA', 'en', 'global']],
  ['en', ['en', 'global']],
  ['et-EE', ['et-EE', 'et', 'global']],
  ['et', ['et', 'global']],
  ['fi-FI', ['fi-FI', 'fi', 'global']],
  ['fi', ['fi', 'global']],
  ['fr-BE', ['fr-BE', 'fr', 'global']],
  ['fr-CH', ['fr-CH', 'fr', 'global']],
  ['fr-FR', ['fr-FR', 'fr', 'global']],
  ['fr-MA', ['fr-MA', 'fr', 'global']],
  ['fr-PF', ['fr-PF', 'fr', 'global']],
  ['fr', ['fr', 'global']],
  ['hr-HR', ['hr-HR', 'hr', 'global']],
  ['hr', ['hr', 'global']],
  ['it-CH', ['it-CH', 'it', 'global']],
  ['it-IT', ['it-IT', 'it', 'global']],
  ['it', ['it', 'global']],
  ['lt-LT', ['lt-LT', 'lt', 'global']],
  ['lt', ['lt', 'global']],
  ['lv-LV', ['lv-LV', 'lv', 'global']],
  ['lv', ['lv', 'global']],
  ['nl-BE', ['nl-BE', 'nl', 'global']],
  ['nl', ['nl', 'global']],
  ['pl-PL', ['pl-PL', 'pl', 'global']],
  ['pl', ['pl', 'global']],
  ['pt-PT', ['pt-PT', 'pt', 'global']],
  ['pt', ['pt', 'global']],
  ['ro-RO', ['ro-RO', 'ro', 'global']],
  ['ro', ['ro', 'global']],
  ['ru-EE', ['ru-EE', 'ru', 'global']],
  ['ru-LV', ['ru-LV', 'ru', 'global']],
  ['ru', ['ru', 'global']],
  ['sk-SK', ['sk-SK', 'sk', 'global']],
  ['sk', ['sk', 'global']],
  ['sl-SI', ['sl-SI', 'sl', 'global']],
  ['sl', ['sl', 'global']],
  ['sr-RS', ['sr-RS', 'sr', 'global']],
  ['sr', ['sr', 'global']],
]);
export const rollupCompiledLocales = new Map([
  ['ar-QT', ['ar-QT']],
  ['ar-SA', ['ar-SA']],
  ['ar-fake', ['ar-fake']],
  ['ar', ['ar']],
  ['cs-CZ', ['cs-CZ']],
  ['cs', ['cs']],
  ['da-DK', ['da-DK']],
  ['da', ['da']],
  ['de-AT', ['de-AT']],
  ['de-BE', ['de-BE']],
  ['de-CH', ['de-CH']],
  ['de-DE', ['de-DE']],
  ['de', ['de']],
  ['el-CY', ['el-CY']],
  ['el-GR', ['el-GR']],
  ['el', ['el']],
  ['en-AE', ['en-AE']],
  ['en-AU', ['en-AU']],
  ['en-BH', ['en-BH']],
  ['en-BN', ['en-BN']],
  ['en-EG', ['en-EG']],
  ['en-ES', ['en-ES']],
  ['en-FJ', ['en-FJ']],
  ['en-GB', ['en-GB']],
  ['en-IE', ['en-IE']],
  ['en-IN', ['en-IN']],
  ['en-KW', ['en-KW']],
  ['en-LB', ['en-LB']],
  ['en-LK', ['en-LK']],
  ['en-MT', ['en-MT']],
  ['en-MU', ['en-MU']],
  ['en-MY', ['en-MY']],
  ['en-NZ', ['en-NZ']],
  ['en-OM', ['en-OM']],
  ['en-PH', ['en-PH']],
  ['en-PK', ['en-PK']],
  ['en-QT', ['en-QT']],
  ['en-SA', ['en-SA']],
  ['en-SG', ['en-SG']],
  ['en-US', ['en-US']],
  ['en-ZA', ['en-ZA']],
  ['en', ['en']],
  ['et-EE', ['et-EE']],
  ['et', ['et']],
  ['fi-FI', ['fi-FI']],
  ['fi', ['fi']],
  ['fr-BE', ['fr-BE']],
  ['fr-CH', ['fr-CH']],
  ['fr-FR', ['fr-FR']],
  ['fr-MA', ['fr-MA']],
  ['fr-PF', ['fr-PF']],
  ['fr', ['fr']],
  ['global', ['global']],
  ['hr-HR', ['hr-HR']],
  ['hr', ['hr']],
  ['it-CH', ['it-CH']],
  ['it-IT', ['it-IT']],
  ['it', ['it']],
  ['lt-LT', ['lt-LT']],
  ['lt', ['lt']],
  ['lv-LV', ['lv-LV']],
  ['lv', ['lv']],
  ['nl-BE', ['nl-BE']],
  ['nl', ['nl']],
  ['pl-PL', ['pl-PL']],
  ['pl', ['pl']],
  ['pt-PT', ['pt-PT']],
  ['pt', ['pt']],
  ['ro-RO', ['ro-RO']],
  ['ro', ['ro']],
  ['ru-EE', ['ru-EE']],
  ['ru-LV', ['ru-LV']],
  ['ru', ['ru']],
  ['sk-SK', ['sk-SK']],
  ['sk', ['sk']],
  ['sl-SI', ['sl-SI']],
  ['sl', ['sl']],
  ['sr-RS', ['sr-RS']],
  ['sr', ['sr']],
]);
export const marketLocales = new Map([]);
